export default __webpack_public_path__ + "static/media/robotdesign.189a33fd.png";